<template>
    <div>
        <az-back-button :route="{name: buscarRotaAnterior, params: {id: patrimonioId}}"
                        :text="filtrarRotaAnterior"/>
        <div class="az-form-content">

            <ajuste-detalhe-cabecalho :ajuste="ajuste" />

            <v-divider/>
            <ajuste-detalhe-campos :ajuste="ajuste" />

            <ajuste-detalhe-patrimonios :ajuste="ajuste" />

            <panel-documentos
                ref="panelDocumentos"
                v-if="ajusteId"
                dono-documento="ajuste"
                :dono-documento-id="ajusteId"
            />
        </div>
    </div>
</template>

<script>
    import {actionTypes} from '@/core/constants'
    import AjusteDetalheCabecalho from './AjusteDetalheCabecalho.vue'
    import AjusteDetalheCampos from './AjusteDetalheCampos.vue'
    import AjusteDetalhePatrimonios from './AjusteDetalhePatrimonios.vue'
    import {mapActions} from 'vuex'
    import PanelDocumentos from '@/views/components/panel/documentos/PanelDocumentos'

    export default {
        name: 'AjusteDetalhe',
        components: {
            AjusteDetalhePatrimonios,
            AjusteDetalheCampos,
            AjusteDetalheCabecalho,
            PanelDocumentos
        },
        data() {
            return {
                ajuste: {},
                rotaOrigem: 'NovoAjuste',
                ajusteId: null
            }
        },
        async mounted() {
            await this.setarAjusteId()
            await this.buscarAjuste()
        },
        computed: {
            buscarRotaAnterior() {
                if (this.$route.query.rotaOrigem) {
                    return this.$route.query.rotaOrigem
                }
                return 'AjusteListagem'
            },
            filtrarRotaAnterior() {
                return this.configurarNomeRotaAnterior()
            },
            patrimonioId() {
                return this.ajuste.patrimonioId
            }
        },
        methods: {
            ...mapActions([
                actionTypes.AJUSTE.BUSCAR_AJUSTE_POR_ID
            ]),
            setarAjusteId() {
                this.ajusteId = this.$route.params.ajusteId
            },
            async buscarAjuste() {
                this.ajuste = await this.buscarAjustePorId(this.ajusteId)
            },
            configurarNomeRotaAnterior() {
                if (this.buscarRotaAnterior === 'NovoAjuste') {
                    return 'Voltar para linha do tempo'
                }
                return 'Voltar para listagem'
            }
        }
    }
</script>
